import { render, staticRenderFns } from "./EditInventoryItemsForm.vue?vue&type=template&id=4d872c46&scoped=true&"
import script from "./EditInventoryItemsForm.vue?vue&type=script&lang=ts&"
export * from "./EditInventoryItemsForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditInventoryItemsForm.vue?vue&type=style&index=0&id=4d872c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d872c46",
  null
  
)

export default component.exports